import { IComponentOptions, IController, ISCEService } from 'angular';
import './video-iframe-modal.component.scss';

export interface IVideoIframeModalData {
  video: string;
}

export class VideoIframeModalController implements IController {
  static $inject = [
    '$sce'
  ];
  data: IVideoIframeModalData;
  onClose: ( data: { result: boolean, delay?: number } ) => void;

  constructor( private $sce: ISCEService ) {
  }

  $onInit() {
  }

  closeModal() {
    this.onClose({ result: null });
  }

  get video() {
    return this.$sce.trustAsResourceUrl(`${this.data.video}?autoplay=1`);
  }
}

export const VideoIframeModalComponent: IComponentOptions = {
  controller: VideoIframeModalController,
  template: require('./video-iframe-modal.component.html'),
  bindings: {
    data: '<',
    onClose: '&'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/video-iframe-modal/video-iframe-modal.component.ts